import React from "react";

export default function Input({
  placeholder,
  iconRight,
  iconLeft,
  type = "text",
  required,
  className,
}) {
  return (
    <div className={`relative ${className}`}>
      {iconLeft && (
        <div className="max-w-[30px] w-full absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
          <img src={iconLeft} alt="Left Icon" />
        </div>
      )}
      <input
        type={type}
        className={`text-[14px] font-[500] font-primary leading-[130%] font-primary focus:placeholder-black focus:outline-none w-full py-[13px] px-[15px] bg-transparent border-[1px] border-[#fff] text-[#fff] placeholder-white 
          ${iconLeft ? "pl-[40px]" : "pl-[15px]"} 
          ${iconRight ? "pr-[40px]" : "pr-[15px]"}`}
        placeholder={placeholder}
        required={required}
      />
      {iconRight && (
        <div className="max-w-[30px] w-full absolute inset-y-0 end-0 flex items-center pr-3 pointer-events-none">
          <img src={iconRight} alt="Right Icon" />
        </div>
      )}
    </div>
  );
}
